module.exports = __webpack_public_path__ + "img/Frame 70796.de1aee9a.png";